import React from 'react'
import styled from 'styled-components'
import PPMori from "../assets/fonts/PPMori-Regular.otf";

export const TermsOfUse = () => {

  const limitaion = 
  [`The CIQ platform and its content are provided "as is" and "as available", without warranties of any kind, express or implied`,
    "SKINSKOOL Inc. does not warrant that the platform will be uninterrupted or error-free",
    "Under no circumstances shall SKINSKOOL Inc. be liable for indirect, incidental, consequential, or exemplary damages",
    "SKINSKOOL Inc.'s total cumulative liability shall not exceed the total amount paid by you in the 6 months preceding the claim"
  ]
    const access = [
        "CIQ is available exclusively to verified business users.",
        "Users must register and create an account to access any part of the dashboard.",
       
    ]
    const service = [
        "Custom product reports based on public product formulation and marketing data",
        `Pre-loaded "Quick Pull" reports curated by the CIQ team`,
        "A database of newly launched products (rolling 6-month window)",
        `Monthly "Highly Searched Products" insights from SKINSKOOLbeauty.com`,
        "Curated third-party Industry News links",
        "Optional premium services, including custom reports and data consulting (subject to additional fees)"
    ]
const dataUse = [
    "Data may contain inaccuracies due to source variability or human error.",
    "CIQ is intended for informational and research purposes only.",
    "Decisions based on CIQ data are made at your own discretion and risk.",    
]
const userResponsibilities = [
  "Copy, scrape, download, extract, or acquire data via automated means (e.g., bots, scrapers)",
  "Share, resell, sublicense, or redistribute CIQ data or login credentials",
  "Engage in any activity that disrupts CIQ's security, functionality, or availability",
  "Attempt unauthorized access to CIQ systems or other user accounts"
]

const terminaaiTools = [
  "Do not upload this data to external AI tools or platforms (including but not limited to: ChatGPT, Gemini, Copilot, Claude, Met AI, DeepSeek, Perplexity etc.) without written permission.",
  "AI models may misinterpret regulatory or formulation information, leading to incorrect conclusions.",
  "Uploading CosmeticIQ data into third-party tools may violate your license agreement and result in revoked access.",
  `For AI-powered insights or interpretation of CosmeticIQ reports, please contact hello@cosmetic-iq.com. We’re happy to provide validated, expert-generated intelligence, tailored to your needs.`
]
  return (
    <Container>
        <Main>
            <Inner>
                <Inner1 >
            <DateTxt>Effective Date <span style={{color:'#202327'}}>May 13, 2025</span></DateTxt>
            <DateTxt>Last Updated <span style={{color:'#202327'}}>May 13, 2025</span></DateTxt>
            </Inner1>
            <Inner1>
            <WelcomeTxt>
            These Terms & Conditions ("Terms") and Privacy Policy govern your access to and use of the CosmeticIQ dashboard ("CIQ"), a product of SKINSKOOL Inc., available at <EmailLink target='_blank' href='https://app.cosmetic-iq.com'>https://app.cosmetic-iq.com</EmailLink>.
            </WelcomeTxt>
            <WelcomeTxt>
            By registering for and/or using CIQ, you agree to these Terms.
            </WelcomeTxt>
            </Inner1>
          <Inner1>
            <QTxt>
                1. Access & Eligibility
            </QTxt>
            <div style={{marginLeft:'1em',display:'flex',flexDirection:'column',gap:12,}}>
            {access.map((txt, index) => (
            <WelcomeTxtList key={index}>
               {txt}
            </WelcomeTxtList>
            ))}
            </div>
           
          </Inner1>
          <Inner1>
            <QTxt>
            2. Services Provided
            </QTxt>
            <WelcomeTxt>
            The CIQ dashboard provides access to:
            </WelcomeTxt>
            <div style={{marginLeft:'1em',display:'flex',flexDirection:'column',gap:12,}}>
            {service.map((txt, index) => (
            <WelcomeTxtList key={index}>
               {txt}
            </WelcomeTxtList>
            ))}
            </div>
           

            </Inner1>
            <Inner1>
            <QTxt>
            3. Data Use & Limitations
            </QTxt>
            <WelcomeTxt>
            Users are granted a limited, non-transferable license to access and utilize CIQ data solely for internal business purposes. Redistribution, resale, or public disclosure of CIQ data without express written consent is strictly prohibited.
            </WelcomeTxt>
            <WelcomeTxt>
            All data accessed via CIQ is aggregated from public sources and compiled using best efforts. While we strive for accuracy, we do not guarantee that the information is complete, up-to-date, or error-free.
            </WelcomeTxt>
            <WelcomeTxt>
            You acknowledge that:
            </WelcomeTxt>
            <div style={{marginLeft:'1em',display:'flex',flexDirection:'column',gap:12,}}>
            {dataUse.map((txt, index) => (
            <WelcomeTxtList key={index}>
               {txt}
            </WelcomeTxtList>
            ))}
            </div>
           

            </Inner1>
            <Inner1>
            <QTxt>
            4. Third-Party Links
            </QTxt>
            <WelcomeTxt>
            The Industry News section includes links to third-party content. We are not responsible for the availability, accuracy, or practices of any third-party sites.
            </WelcomeTxt>
            
           

            </Inner1>
            <Inner1>
            <QTxt>
            5. Intellectual Property
            </QTxt>
            <WelcomeTxt>
            All content and functionality within CIQ, including but not limited to structure, formatting, reports, and platform UX/UI, are the property of SKINSKOOL Inc. and may not be copied, repurposed, or distributed without written permission.
            </WelcomeTxt>
            
           

            </Inner1>
            <Inner1>
            <QTxt>
            6. User Responsibilities & Prohibited Conduct
            </QTxt>
            <WelcomeTxt>
            You agree not to:
            </WelcomeTxt>
            <div style={{marginLeft:'1em',display:'flex',flexDirection:'column',gap:12,}}>
            {userResponsibilities.map((txt, index) => (
            <WelcomeTxtList key={index}>
               {txt}
            </WelcomeTxtList>
            ))}
            </div>
            <WelcomeTxt>
            Violation of these terms may result in immediate termination of access, legal action, and a liquidated damages fee of $25,000 per infraction. SKINSKOOL Inc. reserves the right to pursue further remedies, including injunctive relief and recovery of any additional damages, costs, and legal fees.
            </WelcomeTxt>
      
            </Inner1>
            <Inner1>
            <QTxt>
            7. Fees & Subscription
            </QTxt>
            <WelcomeTxt>
            Use of CIQ is subject to subscription fees. These Terms constitute the agreement between you and SKINSKOOL Inc. regarding your access and use of the platform. By subscribing, you agree to the pricing, billing, and renewal terms outlined at the time of sign-up.
            </WelcomeTxt>
            
            </Inner1>
            <Inner1>
            <QTxt>
            8. Service Availability
            </QTxt>
            <WelcomeTxt>
            We strive to maintain high availability of the CIQ platform but do not guarantee
uninterrupted or error-free access. CIQ may be subject to scheduled maintenance, technical issues, or other disruptions. SKINSKOOL Inc. is not liable for any interruptions or loss of access.
            </WelcomeTxt>
            <WelcomeTxt>
            CIQ is a continually evolving platform and may release features in beta mode. Availability of features is subject to change without prior notice.
            </WelcomeTxt>
            <WelcomeTxt>
            If you do not agree to any future modifications, your sole remedy is to discontinue use of CIQ.
            </WelcomeTxt>
            
            </Inner1>
            <Inner1>
            <QTxt>
            9. Account Security
            </QTxt>
            <WelcomeTxt>
            You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately if you suspect any unauthorized use of your account.
            </WelcomeTxt>
            
            </Inner1>
            <Inner1>
            <QTxt>
            10. Use of CosmeticIQ Data with AI Tools
            </QTxt>
            <WelcomeTxt>
           Your CosmeticIQ reports contain proprietary product and ingredient intelligence derived from our curated closed database.
            </WelcomeTxt>
            
            
            <div style={{marginLeft:'1em',display:'flex',flexDirection:'column',gap:12,}}>
            {terminaaiTools.map((txt, index) => {
  const email = "hello@cosmetic-iq.com";
  if (txt.includes(email)) {
    const parts = txt.split(email);
    return (
      <WelcomeTxtList key={index}>
        {parts[0]}
        <EmailLink href={`mailto:${email}`}>
          {email}
        </EmailLink>
        {parts[1]}
      </WelcomeTxtList>
    );
  } else {
    return <WelcomeTxtList key={index}>{txt}</WelcomeTxtList>;
  }
})}
</div>
</Inner1>
            <Inner1>
            <QTxt>
            11. Termination
            </QTxt>
            <WelcomeTxt>
            We reserve the right to suspend or terminate your access at any time for breach of these Terms, misuse of the platform, or other violations as determined by SKINSKOOL Inc. Termination for breach of these Terms will not entitle you to any refund of prepaid fees.
            </WelcomeTxt>
            
            </Inner1>
            <Inner1>
            <QTxt>
            12. Limitation of Liability
            </QTxt>
            <WelcomeTxt>
            To the fullest extent permitted by law:
            </WelcomeTxt>
            <div style={{marginLeft:'1em',display:'flex',flexDirection:'column',gap:12,}}>
            {limitaion.map((txt, index) => (
            <WelcomeTxtList key={index}>
              {txt}
            </WelcomeTxtList>
            ))}
            </div>
            
            </Inner1>
            <Inner1>
            <QTxt>
            13. Modifications to Terms
            </QTxt>
            <WelcomeTxt>
            We reserve the right to update or modify these Terms at any time. Material changes will be communicated to users via the platform or by email. Continued use of CIQ after such changes constitutes acceptance.
            </WelcomeTxt>
            
            </Inner1>
            <Inner1>
            <QTxt>
            14. Governing Law
            </QTxt>
            <WelcomeTxt>
            These Terms are governed by the laws of Ontario, Canada.
            </WelcomeTxt>
            <WelcomeTxt>
            Questions? Please reach out to <EmailLink href='mailto:hello@cosmetic-iq.com'>hello@cosmetic-iq.com</EmailLink>
            </WelcomeTxt>
            
            </Inner1>
          

           </Inner>
        </Main>
        
    </Container>
  )
}


const Container = styled.div`
// width: 1,228px;
flex:1;


padding: 30px;
gap: 30px;

border: 0px 1px 0px 0px;
// height:75%;
// flex-grow: 1; 

`
const EmailLink = styled.a`
cursor:pointer;
color: #2F3237;
font-weight: 600;
`
const Inner = styled.div`
width: 600px;
display:flex;
flex-direction:column;
gap: 32px;

`
const Inner1 = styled.div`
gap:16px;display:flex;flex-direction:column;`

const Main = styled.div`
padding-top: 60px;
padding-right: 24px;
padding-bottom: 60px;
padding-left: 24px;

border-radius: 24px;
background: #FFFFFF;
overflow:scroll;
box-shadow: 0px 0px 24px 0px #2F323705;

display:flex;
align-items:center;
flex-direction:column;
justify-content:center;
flex-grow: 1; 

`
const DateTxt= styled.p`
font-size: 14px;
font-weight: 700;
line-height: 16.8px;
letter-spacing: -0.01em;
margin:0;

text-underline-position: from-font;
text-decoration-skip-ink: none;
color: #20232799;
font-family:PPMori;

`
const WelcomeTxt= styled.p`

font-size: 16px;
font-weight: 500;
line-height: 22.4px;
letter-spacing: 0%;
font-family:PPMori;
margin:0;

text-underline-position: from-font;
text-decoration-skip-ink: none;
color: #2F3237;

`

const WelcomeTxtList= styled.p`

font-size: 16px;
font-weight: 500;
line-height: 22.4px;
letter-spacing: 0%;
font-family:PPMori;
margin:0;
 position: relative;
  padding-left: 1em;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color: #2F3237;
list-style:none;
 &::before {
    content: '•';
    position: absolute;
    left:0;
    bottom:0;
    top:0;
    // background:Red;
    
    font-size: 1.1em; 
    line-height: 1.2;
  }

`
const QTxt = styled.p`

font-size: 22px;
font-weight: 600;
line-height: 26.4px;
letter-spacing: 0%;
font-family:PPMori;
margin:0;

text-underline-position: from-font;
text-decoration-skip-ink: none;
color: #2F3237;
`

const Title = styled.p`

color: #202327;
font-size: 24px;
font-weight: 600;
line-height: 110.00000000000001%;
letter-spacing: -1%;
margin:0;
font-family:PPMori;
`


const ReachoutText = styled.p`
@font-face {
    src: url(${PPMori}) format('truetype');
   font-family:PPMori;
  }

font-family:PPMori;
font-size: 14px;
font-weight: 700;
line-height: 16.8px;
letter-spacing: -0.01em;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:background: #2F3237;

`